import React from "react";
import "./AboutStyles.css";
import Lottie from "react-lottie";
import animationData from "../Lottie/Programming.json";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import Bounce from "react-reveal/Bounce";
import Slide from "react-reveal/Slide";
import LightSpeed from "react-reveal/LightSpeed";
import Zoom from "react-reveal/Zoom";
import myResume from "./Resume-converted-compressed.pdf";

function About() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
  };

  return (
    <div id="about" className="about">
      <div className="about__top">
        <Bounce left>
          <h1 className="about__heading">About me</h1>
          <p className="about__subheading">My Introduction</p>
        </Bounce>
      </div>
      <div className="about__content">
        <Zoom left>
          <div className="lottie__wrapper">
            <Lottie
              options={defaultOptions}
              width={window.innerWidth > "768px" ? 500 : 250}
            />
          </div>
        </Zoom>
        <div className="right">
          <div className="right__top">
            <Slide bottom>
              <p className="about__text">
                Passionate and curiosity driven software developer with an eye
                in design and web development. Ready to dive into writing clean
                code and building accessible web applications with great user
                experience. I enjoy solving problems, writing and building
                products. I like to peek under the hood, tinker with
                technologies and learn new skills. I'm quietly confident,
                naturally curious, and perpetually working on improving my
                skills.
              </p>
            </Slide>
          </div>
          <LightSpeed>
            <div className="right__bottom">
              <div className="about__figures">
                <div className="figureWrapper">
                  <VisibilitySensor partialVisibility offset={{ bottom: 200 }}>
                    {({ isVisible }) => (
                      <h3 style={{ height: 20 }}>
                        {isVisible ? <CountUp end={4} duration={2} /> : null} +
                      </h3>
                    )}
                  </VisibilitySensor>
                  <p>Years of Experience</p>
                </div>
                <div className="figureWrapper">
                  <VisibilitySensor partialVisibility offset={{ bottom: 200 }}>
                    {({ isVisible }) => (
                      <h3 style={{ height: 20 }}>
                        {isVisible ? <CountUp end={10} duration={2} /> : null} +
                      </h3>
                    )}
                  </VisibilitySensor>
                  <p>Projects Completed</p>
                </div>
                <div className="figureWrapper">
                  <VisibilitySensor partialVisibility offset={{ bottom: 200 }}>
                    {({ isVisible }) => (
                      <h3 style={{ height: 20 }}>
                        {isVisible ? <CountUp end={15} duration={2} /> : null} +
                      </h3>
                    )}
                  </VisibilitySensor>
                  <p>Certificates earned</p>
                </div>
              </div>
            </div>
            <a
              href={myResume}
              download="Resume-converted-compressed.pdf"
              className="about__btn"
            >
              DOWNLOAD CV
            </a>
          </LightSpeed>
        </div>
      </div>
    </div>
  );
}

export default About;
